<template>
  <div class="tusd-wrap wrap-bg">
  	<div class="page-title"><i class="back-btn" @click="goBack"></i>交易详情</div>
  	<div class="separator"></div>
	 <template v-if="show">
			<div class="record-info">
				<div class="page-item">
					<span class='page-item-label'>日期：</span>
					<span class="page-item-content">{{detail.DateStr}}</span>
				</div>
				<div class="page-item">
					<span class='page-item-label'>类型：</span>
					<span class="page-item-content">{{detail.StreamTypeName}}</span>
				</div>
				<div class="page-item">
					<span class='page-item-label'>订单号：</span>
					<span class="page-item-content">{{detail.OrderNo}}</span>
				</div>
				<div class="page-item">
					<span class='page-item-label'>金额：</span>
					<span class="page-item-content">{{detail.StreamMoney}}</span>
				</div>
				<div class="page-item">
					<span class='page-item-label'>手续费：</span>
					<span class="page-item-content">{{detail.Fee}}</span>
				</div>
				<!-- <div class="page-item">
					<span class='page-item-label'>转出地址：</span>
					<span class="page-item-content">{{detail.FromAddress}}</span>
				</div>
				<div class="page-item">
					<span class='page-item-label'>转入地址：</span>
					<span class="page-item-content">{{detail.ToAddress}}</span>
				</div>
				<div class="page-item">
					<span class='page-item-label'>TXID：</span>
					<span class="page-item-content">{{detail.TxID}}</span>
				</div>
				<div class="page-item">
					<span class='page-item-label'>备注：</span>
					<span class="page-item-content">{{detail.Remark}}</span>
				</div> -->
			</div>
	 </template>
	<template v-else>
			<div class="record-info">
				<div class="page-item">
					<span class='page-item-label'>日期：</span>
					<span class="page-item-content">{{detail.DateStr}}</span>
				</div>
				<div class="page-item">
					<span class='page-item-label'>订单号：</span>
					<span class="page-item-content">{{detail.OrderNo}}</span>
				</div>
				<div class="page-item">
					<span class='page-item-label'>类型：</span>
					<span class="page-item-content">{{detail.StreamTypeName}}</span>
				</div>
				<div class="page-item">
					<span class='page-item-label'>金额：</span>
					<span class="page-item-content">{{detail.StreamMoney}}</span>
				</div>
			</div>
		</template>
  
  </div>
</template>

<script>
import { get } from 'http';
export default {
  name: 'recordDetails',
  data(){
  	return {
		show:true,
		detail:{},
  		params:{}
  	}
  },
  methods:{
	getCoinUpDetail(orderinfo){
		this.$api.getCoinUpDetail(orderinfo).then(res=>{
			this.detail=res.data;
		});
	},
  	goBack(){
  		this.$router.push({name:this.params.back})
  	}
  },
  created(){
	  this.params = this.$store.state.routerStore.recordDetails;
	  let type=this.params.orderinfo.type;
	  if(type==1||type==2){
		  this.show=false;
	  }
	  this.getCoinUpDetail(this.params.orderinfo);
  }
}
</script>
<style scoped>
.page-item .page-item-label{
	width: 120px;
}
.page-item .page-item-content{
	word-break: break-all;
}
</style>
